module.exports = __webpack_public_path__ + "static/tp-feature-3-c6f0afa2c69c8e19c2f237eac94612a2.png";